import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-test-report',
  templateUrl: './test-report.component.html',
  styleUrls: ['./test-report.component.css']
})
export class TestReportComponent implements OnInit {
  Submitted:boolean = false;
  BookTitleList=[];
  ChapterHeadingList=[];
  ChapterTopicList=[];
  SearchChapterHeadingList=[];
  SearchChapterTopicList=[];
  ChapterContentList=[];

  constructor(private learningservice:LearningService,private LookupService: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService,private _sanitizer: DomSanitizer) { }

    SearchModel = {    
      WorkSheetTypeID: 0,     
      ClassID:0,
      SectionID:0,
      WorkSheetID:0,
   };
   
   Clear(){
     this.SearchModel.WorkSheetTypeID=0;
     this.SearchModel.ClassID=0;
     this.SearchModel.SectionID=0;
     this.SearchModel.WorkSheetID=0;
     this.TestReportList=[];
   }
 
TestReportList=[];
GetAllTestReport() {
  this.spinnerService.show();
  this.learningservice.GetAllTestReport(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
    this.TestReportList = data.TestReportList;
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
  });
};

ContentModel = {  
  WSTestID:0,
  WorkSheetID:0,
  WorkSheetTitle: '',  
  FirstName:'',
 
};

GetContent(item){  
  this.TestQuestionList=[];
  this.ContentModel.WSTestID=item.WSTestID;
  this.ContentModel.WorkSheetID=item.WorkSheetID;
  this.ContentModel.WorkSheetTitle=item.WorkSheetTitle; 
  this.ContentModel.FirstName=item.FirstName;  
  this.GetAllTestQuestions();
  
}

TestQuestionList=[];
GetAllTestQuestions() {
  this.spinnerService.show();
  this.learningservice.GetAllTestQuestions(JSON.stringify(this.ContentModel)).subscribe((data: any) => {
    this.TestQuestionList = data.TestQuestionList;
    this.spinnerService.hide();
    this.IsmodelShow=true;
    this.globalHelper.CheckActionStatus(data);
    
    // if(this.TestQuestionList!=null && this.TestQuestionList.length>0){
    //   var AttemptCount=0;
    //   var CorrectCount=0;
    //   var InCorrectCount=0;
    //   var TestScore=0;
    //   for(var i=0;i<this.TestQuestionList.length;i++){
    //     if(this.TestQuestionList[i].QStatus=='A'){
    //       AttemptCount=AttemptCount+1;
    //     }
    //     if(this.TestQuestionList[i].QuestionTypeID==1 && ((this.TestQuestionList[i].ROP1 && this.TestQuestionList[i].AROP1)||(this.TestQuestionList[i].ROP2 && this.TestQuestionList[i].AROP2 ))){
    //       CorrectCount=CorrectCount+1;
    //       TestScore=TestScore+this.TestQuestionList[i].QValue;
    //     }
    //     if((this.TestQuestionList[i].QuestionTypeID==3)  && ((this.TestQuestionList[i].ROP1 && this.TestQuestionList[i].AROP1)||(this.TestQuestionList[i].ROP2 && this.TestQuestionList[i].AROP2)||(this.TestQuestionList[i].ROP3 && this.TestQuestionList[i].AROP3)||(this.TestQuestionList[i].ROP4 && this.TestQuestionList[i].AROP4 ))){
    //       CorrectCount=CorrectCount+1;
    //       TestScore=TestScore+this.TestQuestionList[i].QValue;
    //     }
    //     if((this.TestQuestionList[i].QuestionTypeID==2)  && ( (this.TestQuestionList[i].Options==1 && this.TestQuestionList[i].ROP1 && this.TestQuestionList[i].AROP1) || (this.TestQuestionList[i].Options==2 && ((this.TestQuestionList[i].ROP2==this.TestQuestionList[i].AROP2) &&(this.TestQuestionList[i].ROP1==this.TestQuestionList[i].AROP1)))||(this.TestQuestionList[i].Options==3 && ((this.TestQuestionList[i].ROP3==this.TestQuestionList[i].AROP3) && (this.TestQuestionList[i].ROP2 == this.TestQuestionList[i].AROP2) && (this.TestQuestionList[i].ROP1 == this.TestQuestionList[i].AROP1)))||(this.TestQuestionList[i].Options==4 && ((this.TestQuestionList[i].ROP4 == this.TestQuestionList[i].AROP4 ) && (this.TestQuestionList[i].ROP3 == this.TestQuestionList[i].AROP3 )&& (this.TestQuestionList[i].ROP2 == this.TestQuestionList[i].AROP2 ) && (this.TestQuestionList[i].ROP1== this.TestQuestionList[i].AROP1))))){
    //       CorrectCount=CorrectCount+1;
    //       TestScore=TestScore+this.TestQuestionList[i].QValue;
    //     }
    //     if((this.TestQuestionList[i].QuestionTypeID==4)  && ((this.TestQuestionList[i].Options==1 && this.TestQuestionList[i].RFOP1== this.TestQuestionList[i].ARFOP1)||(this.TestQuestionList[i].Options==2 && this.TestQuestionList[i].RFOP2==this.TestQuestionList[i].ARFOP2 && this.TestQuestionList[i].RFOP1==this.TestQuestionList[i].ARFOP1)||(this.TestQuestionList[i].Options==3 && this.TestQuestionList[i].RFOP3==this.TestQuestionList[i].ARFOP3)||(this.TestQuestionList[i].Options==4 && this.TestQuestionList[i].RFOP4==this.TestQuestionList[i].ARFOP4 && this.TestQuestionList[i].RFOP3==this.TestQuestionList[i].ARFOP3 && this.TestQuestionList[i].RFOP2==this.TestQuestionList[i].ARFOP2 && this.TestQuestionList[i].RFOP1==this.TestQuestionList[i].ARFOP1) )){
    //       CorrectCount=CorrectCount+1;
    //       TestScore=TestScore+this.TestQuestionList[i].QValue;
    //     }
        
    //   }
    //   InCorrectCount=this.TestQuestionList.length-CorrectCount;
    //   this.ContentModel.TotalQuestion=this.TestQuestionList.length.toString();
    //   this.ContentModel.AttemptCount=AttemptCount.toString();
    //   this.ContentModel.CorrectCount=CorrectCount.toString();
    //   this.ContentModel.InCorrectCount=InCorrectCount.toString();
    //   this.ContentModel.TestScore=TestScore.toString();
    // }
  });
};

  ngOnInit() {
    this.GetClass();
    this.GetSection();
    this.GetWorkSheetType();    
    this.GetClassTestTitle();
  }
  ClassList=[];
  GetClass() {
    this.LookupService.GetLookupsList('LPClass', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  }
  GetBookTitle() {
    this.LookupService.GetLookupsList('LearningBookTitle', '').subscribe((data: any) => {
      this.BookTitleList = data.LookupItems;
    });
  }
  ClassSectionList: any;
  GetClassSection() {
    this.LookupService.GetLookupsList('STClassSection', '').subscribe((data) => {
      this.ClassSectionList = data.LookupItems;
    
    });

  };
  
  SectionList=[];
  GetSection() {
    this.SearchModel.SectionID=0;
    var ItemBO={
     'ItemID':this.SearchModel.ClassID
   }
    this.LookupService.GetLookupsList('LPSection', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
    });
  }

  TestTitleList=[];
  GetClassTestTitle() {
    this.SearchModel.WorkSheetID=0;
    this.TestReportList=[];
    var ItemBO={
     'ItemID':this.SearchModel.ClassID
   }
    this.LookupService.GetLookupsList('ClassTestTitle', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.TestTitleList = data.LookupItems;
    });
  }

  WorkSheetTypeList=[];
  GetWorkSheetType() {
     this.LookupService.GetLookupsList('WorkSheetType', '').subscribe((data: any) => {
      this.WorkSheetTypeList = data.LookupItems;
    });
  }
  ClearList(){
    this.TestReportList=[];
  }
  WorksheetModel = {  
    WorkSheetID:0,
    WorkSheetTitle: '',  
    WorkSheetType:'',
   
  };

  // Worksheet
  TestWorksheetList=[];
  IsmodelShow=false;
  GetWorksheet(item){
    this.TestWorksheetList=[];
    this.IsmodelShow=false;
    this.WorksheetModel.WorkSheetID=item.WorkSheetID;
    this.WorksheetModel.WorkSheetTitle=item.WorkSheetTitle;  
    this.WorksheetModel.WorkSheetType=item.WorkSheetType;  
    this.GetAllTestWorksheet();
  }
 
  GetAllTestWorksheet() {
  this.spinnerService.show();
  this.learningservice.GetAllTestWorksheet(JSON.stringify(this.WorksheetModel)).subscribe((data: any) => {
    this.TestWorksheetList = data.TestWorksheetList;
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);   
  });
};

CloseModel(){
  this.IsmodelShow=false;
}


// Download
FilePath: any;
TestReportDownload(){
  this.spinnerService.show();
  this.learningservice.TestReportDownload(JSON.stringify(this.WorksheetModel)).subscribe((data: any) => {
    this.FilePath = data.FilePath;
    window.location = data.FilePath;
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);   
  });

}


// Print

PrintTestReport(){
  var url = "testreportprint?WorksheetID=" + this.WorksheetModel.WorkSheetID;
  this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
}

PrintStudentTest(){
  var url = "studenttestreportprint?WSTestID=" + this.ContentModel.WSTestID+ "&WorkSheetID=" + this.ContentModel.WorkSheetID;
  this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
}
}






